import React from 'react';
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from 'react-router-dom';
import { QuestionnaireProvider } from './context/QuestionnaireContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import ThemeToggle from './components/ThemeToggle/ThemeToggle.jsx'
import routes from './routes/routes';
import './App.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'katex/dist/katex.min.css';

const AppContent = () => {
  const { theme } = useTheme();
  
  return (
    <Router basename='/exam'>
      <div className={theme === 'dark' ? 'dark-gradient-pattern' : 'light-gradient-pattern'}>
        <ThemeToggle />
        
        <ToastContainer 
          position="top-right" 
          autoClose={3000} 
          hideProgressBar={false} 
          newestOnTop={false} 
          closeOnClick 
          rtl={false} 
          pauseOnFocusLoss 
          draggable 
          pauseOnHover 
          theme={theme}
        />
        
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </div>
    </Router>
  );
};

// App Component
const App = () => {
  return (
    <ThemeProvider>
      <QuestionnaireProvider>
        <AppContent />
      </QuestionnaireProvider>
    </ThemeProvider>
  );
};

export default App;

